var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2447_6377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.30598 6.61164H0.828125C0.646918 6.61164 0.5 6.46473 0.5 6.28352V0.805664C0.5 0.624457 0.646918 0.477539 0.828125 0.477539H2.14062C2.32183 0.477539 2.46875 0.624457 2.46875 0.805664V2.94154C3.72036 1.55157 5.53836 0.681797 7.55947 0.69648C11.303 0.72366 14.2983 3.74867 14.2903 7.49228C14.2824 11.2307 11.2494 14.2588 7.50911 14.2588C5.75667 14.2588 4.15961 13.594 2.9561 12.5029C2.81667 12.3765 2.81025 12.1596 2.94333 12.0266L3.87211 11.0978C3.99445 10.9755 4.191 10.9688 4.32058 11.0834C5.16922 11.8344 6.28539 12.29 7.50911 12.29C10.1688 12.29 12.3216 10.1376 12.3216 7.47754C12.3216 4.81789 10.1692 2.66504 7.50911 2.66504C5.90961 2.66504 4.49364 3.44368 3.6188 4.64289H6.30598C6.48719 4.64289 6.63411 4.78981 6.63411 4.97102V6.28352C6.63411 6.46473 6.48719 6.61164 6.30598 6.61164V6.61164Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2447_6377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.477539)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoIcon);
export default __webpack_public_path__ + "static/media/undoIcon.e09156f4460196cb40568a1bc088903d.svg";
export { ForwardRef as ReactComponent };